export const joinPaths = (baseUrl: string, ...paths: string[]): string => {
  const base = new URL(baseUrl);
  const combinedPath = paths.map((path) => path.replace(/^\/+|\/+$/g, '')).join('/');
  const joinedUrl = new URL(combinedPath, base);
  return joinedUrl.href;
};
